import { render, staticRenderFns } from "./list.vue?vue&type=template&id=2e9c72c4&scoped=true&"
import script from "./list.vue?vue&type=script&lang=ts&"
export * from "./list.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e9c72c4",
  null
  
)

component.options.__file = "list.vue"
export default component.exports